module.exports = __webpack_public_path__ + "static/media/file.f08921b5.svg";